import { array } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';

import DOMPurify from 'dompurify';

import type { Billing, Service } from 'webapp-types';

import joinClasses from 'webapp/helpers/join-classes';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormCheckboxComponent from 'webapp/components/form/checkbox';

export interface Args {
	model: Billing.Addon;
	selectedAddons: Billing.Addon[];
	onChange: (addon: Billing.Addon) => void;
}

export default class AccountBillingAddonsOptionComponent extends Component<Args> {
	@service('popup') declare popupService: Service.Popup;
	@service('billing') declare billingService: Service.Billing;

	get isSelected() {
		return this.args.selectedAddons.includes(this.args.model);
	}

	get optionClass() {
		return `account-billing-addons-option-${this.args.model.id}`;
	}

	get price() {
		const activePlan = this.billingService.activePlan,
			billingCycle = activePlan?.billingCycle,
			price = billingCycle ? this.args.model.prices[billingCycle] : null;

		return htmlSafe(
			DOMPurify.sanitize(`<span>${price?.priceFormatted}</span> /${price?.cycleText}`, {
				ALLOWED_TAGS: ['span'],
			}),
		);
	}

	@action
	selectOption(event: PointerEvent) {
		event.preventDefault();

		this.args.onChange(this.args.model);
	}

	@action
	doNothing() {
		// what the method name says
	}
	<template>
		<div
			role="button"
			class={{joinClasses
				(array
					"account-billing-addons-option" this.optionClass (if this.isSelected "selected")
				)
			}}
			{{on "click" this.selectOption}}
		>
			<div class="option__checkbox">
				<FormCheckboxComponent
					@name="select-addon"
					@selected={{this.isSelected}}
					@onChange={{this.doNothing}}
				/>
			</div>
			<div class="option__content">

				<div class="option__header">
					<CommonUiIconComponent @name={{@model.icon}} @size="lg" />
					<strong class="title">{{@model.name}}</strong>
					{{#if this.price}}
						<span class="price">{{this.price}}</span>
					{{else}}
						<div class="free-tag"></div>
					{{/if}}
				</div>

				<div class="option__description">
					{{{@model.description}}}
				</div>

			</div>
		</div>
	</template>
}
